import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.ash,
  paraColor: colors.ash,
  subHeadingColor: colors.ash,
  bgColor: colors.cream,
  ctaColor: colors.coral,
  textColorDark: colors.ash,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;